import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/reducers'
import { Observable } from 'rxjs'
import { CountableSummary } from 'src/app/models/period-aggregate-amounts.model'
import {
  getPosPhysicalEstimates,
  getLoading,
} from 'src/app/selectors/period-aggregate-amounts.selector'
import { Artist } from 'src/app/models/artist.model'
import { getSelectedArtist } from 'src/app/selectors/artist.selector'
import {
  getDataCollectByPosPhysicalEstimates,
  getDataCollectLoading,
} from 'src/app/selectors/data-collections.selector'

@Component({
    selector: 'app-aggregated-amounts-pos-physical-estimate',
    templateUrl: './aggregated-amounts-pos-physical-estimate.component.html',
    styleUrls: ['./aggregated-amounts-pos-physical-estimate.component.scss'],
    standalone: false
})
export class AggregatedAmountsPosPhysicalEstimateComponent implements OnInit {
  posPhysicalEstimateModel$: Observable<CountableSummary>
  loading$: Observable<boolean>
  selectedArtist$: Observable<Artist>

  dataCollections$: Observable<boolean>
  dataCollectLoading$: Observable<boolean>

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.posPhysicalEstimateModel$ = this.store.select(getPosPhysicalEstimates)
    this.selectedArtist$ = this.store.select(getSelectedArtist)
    this.loading$ = this.store.select(getLoading)

    this.dataCollections$ = this.store.select(getDataCollectByPosPhysicalEstimates)
    this.dataCollectLoading$ = this.store.select(getDataCollectLoading)
  }
}
